import { render } from "./ChatContainerReader.vue?vue&type=template&id=51d488e6&scoped=true"
import script from "./ChatContainerReader.vue?vue&type=script&lang=js"
export * from "./ChatContainerReader.vue?vue&type=script&lang=js"

import "./ChatContainerReader.vue?vue&type=style&index=0&id=51d488e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d488e6"]])

export default __exports__